module.exports = __webpack_public_path__ + "fonts/Lato-SemiboldItalic.82b587d9.eot";